import {
  IonAlert,
  IonButton,
  IonContent,
  IonFooter,
  IonPage,
  IonTitle,
  useIonToast,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { useContext, useState } from "react";
import { AuthenticationContext } from "../../../providers/AuthenticationProvider/AuthenticationProvider";
import useUserGroups from "../../../hooks/groups/useUserGroups";
import useDeleteGroup from "../../../hooks/groups/useDeleteGroup";
import Spinner from "../../../components/Spinner/Spinner";
import GroupCard from "../../../components/GroupCard/GroupCard";

const GroupManager = () => {
  const { appUserId } = useContext(AuthenticationContext);
  const { data, error, isLoading, refreshData } = useUserGroups(appUserId);
  const deleteGroup = useDeleteGroup();
  const [present] = useIonToast();
  const [groupToDelete, setGroupToDelete] = useState(null);

  useIonViewWillEnter(() => {
    refreshData();
  });

  const confirmDelete = async () => {
    if (!groupToDelete) return;
    try {
      await deleteGroup(groupToDelete.id);
      refreshData();
      present({
        message: `Gruppo "${groupToDelete.description}" eliminato`,
        duration: 3000,
        color: "primary",
        position: "bottom",
      });
    } catch (err) {
      console.error(err);
      present({
        message: "Errore durante l'eliminazione del gruppo",
        duration: 3000,
        color: "danger",
        position: "bottom",
      });
    } finally {
      setGroupToDelete(null);
    }
  };

  return (
    <IonPage>
      <IonContent>
        {isLoading && <Spinner />}
        {error && <p>Error: {error.message}</p>}
        {data && data.length > 0 && (
          <div>
            <IonTitle
              style={{
                color: "#062a40",
              }}
            >
              <h1>Gruppi che alleni</h1>
            </IonTitle>
            {data.map((group) => (
              <GroupCard
                key={group.id}
                data={group}
                onDeleteRequest={setGroupToDelete}
              />
            ))}
          </div>
        )}
      </IonContent>
      <IonAlert
        isOpen={!!groupToDelete}
        header="Elimina gruppo"
        message={
          groupToDelete
            ? `Vuoi eliminare il gruppo "${groupToDelete.description}"? Le lezioni e le pianificazioni già create non verranno toccate.`
            : ""
        }
        buttons={[
          {
            text: "Annulla",
            role: "cancel",
            handler: () => setGroupToDelete(null),
          },
          {
            text: "Elimina",
            role: "destructive",
            handler: confirmDelete,
          },
        ]}
        onDidDismiss={() => setGroupToDelete(null)}
      />
      <IonFooter className="ion-no-border ion-padding">
        <IonButton
          routerLink={`/admin/groups/add`}
          color="success"
          expand="block"
          size="large"
        >
          Aggiungi
        </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default GroupManager;
